import { getServerSession } from '../api/sessionAPI';
import { getViewAsToken, isViewAs } from '../viewAs/viewAsSession';

import { getMsUntilExpiry } from './tokenUtils';

/**
 * Whether the page has a live session. HA-445: from the API's session (read before the app renders),
 * not a token cookie; HA-447: a view-as tab is signed in as the viewed member while its session lasts.
 */
export default function isAuthenticated(): boolean {
  if (isViewAs() ? !getViewAsToken() : !getServerSession()) {
    return false;
  }

  const msUntilExpiry = getMsUntilExpiry();

  return msUntilExpiry != null && msUntilExpiry > 0;
}
